<template>
  <v-card class="export-booking">
    <v-card-title>{{ $t('admin_acc_booking.export') }}</v-card-title>
    <v-card-text>
      <v-col cols="12" class="overflow-y-auto pt-2">
        <v-form v-model="isFormValid"
                ref="addBookingForm">
          <v-input :rules="requiredRules"
                   v-model="start">
            <v-container fluid class="flex-column pa-0">
              <legend class="v-label theme--light">{{ $t('admin_acc_booking_add.start_time') }}</legend>
              <DateTimePickerInput v-model="start"
                                   hide-details></DateTimePickerInput>
            </v-container>
          </v-input>
          <v-input :rules="requiredRules"
                   v-model="end">
            <v-container fluid class="flex-column pa-0">
              <legend class="v-label theme--light">{{ $t('admin_acc_booking_add.end_time') }}</legend>
              <DateTimePickerInput v-model="end"
                                   hide-details></DateTimePickerInput>
            </v-container>
          </v-input>
        </v-form>
      </v-col>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="cancel"
             class="mr-3"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             depressed
             large
             @click="$refs.addBookingForm.validate() && save()">
        {{ $t('save') }}
        <v-icon right>fas fa-check</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {ref} from "@vue/composition-api";
import DateTimePickerInput from "@/components/DateTimePickerInput";
import {DateTime} from "luxon";

export default {
  name: 'ExportBookingModal',
  components: {DateTimePickerInput},
  setup(props, {root, emit}) {
    const cancel = function () {
      emit('submit');
    };

    // Form
    const isFormValid = ref(false);
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const start = ref(DateTime.now().startOf('day').toISO());
    const end = ref(DateTime.now().endOf('day').toISO());

    const save = function () {
      root.$downloadFile('aafb/admin/bookings/export/', {
        start_time: start.value,
        end_time: end.value,
      }, 'bookings.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      emit('submit');
    }

    return {
      cancel,

      isFormValid,
      requiredRules,
      start,
      end,
      save,
    }
  },
}
</script>

<style lang="less">
.add-booking {
  .v-card__text {
    display: flex;
    height: 75vh;
    padding: 0;
  }
}
</style>
